import FeaturesContainer from './FeaturesContainer'

export default FeaturesContainer
